import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import PortalVue from "portal-vue";
// import VueSocketIO from 'vue-socket.io';
import {
  fetchInstance,
  fetchLookupData,
  setOidcManager,
} from "@/apis";
import { createOidcAuth, SignInType } from "@/auth/createOidcAuth";
import { EventBus } from "./EventBus";
import { fetchDefData } from "./apis";
import Highcharts from "highcharts";
import Stock from "highcharts/modules/stock";
import HighchartsVue from "highcharts-vue";
import "./registerServiceWorker";
import { cloneDeep, isEmpty } from "./utils/object";
import "@fontsource/roboto"; // Defaults to weight 400
import {  WebStorageStateStore } from "oidc-client";

Vue.config.productionTip = false;

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'http://192.168.1.20:8090',
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   }
// }))
Stock(Highcharts);
Vue.use(HighchartsVue);

// ==================== Global Error Page Component ====================

const ErrorPage = {
  name: "ServerErrorPage",

  data() {
    return {
      retrying: false,
    };
  },

  methods: {
    reload() {
      if (this.retrying) return;
      this.retrying = true;
      window.location.reload();
    },
  },

  render(h) {
    const C = {
      navy: "#193957",
      navyDark: "#142F4D",
      text: "#22364B",
      muted: "#667789",
      border: "#E1E6EC",
      background: "#F4F6F8",
      gold: "#9D814F",
      goldBg: "#F9F7F2",
    };

    const icon = (name, size, color) =>
      h("i", {
        class: `mdi mdi-${name}`,
        attrs: { "aria-hidden": "true" },
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: `${size}px`,
          lineHeight: "1",
          color,
          flexShrink: "0",
        },
      });

    return h(
      "main",
      {
        attrs: {
          dir: "rtl",
        },
        style: {
          width: "100%",
          minHeight: "100vh",
          minHeight: "100dvh",
          padding: "24px 16px",
          boxSizing: "border-box",
          background: C.background,
          fontFamily: "IranYekan",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
      [
        h(
          "section",
          {
            attrs: {
              "aria-labelledby": "server-error-title",
            },
            style: {
              width: "100%",
              maxWidth: "480px",
              background: "#FFFFFF",
              border: `1px solid ${C.border}`,
              borderRadius: "18px",
              boxShadow: "0 16px 48px rgba(25,57,87,0.055)",
              overflow: "hidden",
              boxSizing: "border-box",
            },
          },
          [
            h("div", {
              style: {
                height: "4px",
                background: C.navy,
              },
            }),

            h(
              "header",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  padding: "22px 24px",
                  borderBottom: `1px solid ${C.border}`,
                },
              },
              [
                h(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      minWidth: "0",
                    },
                  },
                  [
                    h(
                      "div",
                      {
                        style: {
                          width: "43px",
                          height: "43px",
                          borderRadius: "11px",
                          background: C.navy,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: "0",
                        },
                      },
                      [icon("shield-check-outline", 25, "#FFFFFF")],
                    ),

                    h("div", [
                      h(
                        "div",
                        {
                          style: {
                            color: C.text,
                            fontSize: "14px",
                            fontWeight: "800",
                            lineHeight: "1.9",
                          },
                        },
                        "سامانه خدمات بیمه‌ای",
                      ),

                      h(
                        "div",
                        {
                          style: {
                            color: "#8793A0",
                            fontSize: "11px",
                            lineHeight: "1.8",
                          },
                        },
                        "درگاه خدمات الکترونیکی",
                      ),
                    ]),
                  ],
                ),

                h(
                  "div",
                  {
                    style: {
                      width: "36px",
                      height: "36px",
                      borderRadius: "10px",
                      background: "#F0F3F6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: "0",
                    },
                  },
                  [icon("domain", 20, "#657587")],
                ),
              ],
            ),

            h(
              "div",
              {
                style: {
                  padding: "38px 24px 28px",
                  textAlign: "center",
                },
              },
              [
                h(
                  "div",
                  {
                    style: {
                      width: "112px",
                      height: "112px",
                      borderRadius: "50%",
                      background: "#EFF3F7",
                      margin: "0 auto 30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    },
                  },
                  [
                    h(
                      "div",
                      {
                        style: {
                          width: "78px",
                          height: "78px",
                          borderRadius: "20px",
                          background: "#FFFFFF",
                          border: "1px solid #DFE5EC",
                          boxShadow: "0 7px 18px rgba(25,57,87,0.05)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      },
                      [icon("server-network-off", 39, C.navy)],
                    ),
                  ],
                ),

                h(
                  "h1",
                  {
                    attrs: {
                      id: "server-error-title",
                    },
                    style: {
                      color: C.navyDark,
                      fontSize: "21px",
                      fontWeight: "800",
                      lineHeight: "1.8",
                      margin: "0 0 13px",
                    },
                  },
                  "ارتباط با سامانه برقرار نشد",
                ),

                h(
                  "p",
                  {
                    style: {
                      maxWidth: "355px",
                      margin: "0 auto 30px",
                      color: C.muted,
                      fontSize: "13px",
                      lineHeight: "2.2",
                    },
                  },
                  "در حال حاضر امکان برقراری ارتباط با سرور وجود ندارد. لطفاً دقایقی دیگر مجدداً تلاش کنید.",
                ),

                h(
                  "div",
                  {
                    attrs: {
                      role: "status",
                    },
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: "10px",
                      background: C.goldBg,
                      border: "1px solid #EAE3D6",
                      borderRadius: "11px",
                      padding: "15px",
                      marginBottom: "18px",
                    },
                  },
                  [
                    h(
                      "div",
                      {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          color: "#6C604A",
                          fontSize: "12px",
                          fontWeight: "600",
                        },
                      },
                      [icon("information-outline", 19, C.gold), "وضعیت خدمات"],
                    ),

                    h(
                      "span",
                      {
                        style: {
                          color: "#856D45",
                          fontSize: "12px",
                          fontWeight: "700",
                        },
                      },
                      "موقتاً در دسترس نیست",
                    ),
                  ],
                ),

                h(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      disabled: this.retrying,
                      "aria-label": "تلاش مجدد برای اتصال به سامانه",
                    },
                    style: {
                      width: "100%",
                      minHeight: "51px",
                      border: "none",
                      borderRadius: "10px",
                      background: C.navy,
                      color: "#FFFFFF",
                      fontFamily: "IranYekan",
                      fontSize: "14px",
                      fontWeight: "700",
                      cursor: this.retrying ? "wait" : "pointer",
                      opacity: this.retrying ? 0.7 : 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      transition: "opacity 0.2s ease",
                    },
                    on: {
                      click: this.reload,
                    },
                  },
                  [
                    icon(this.retrying ? "loading" : "refresh", 20, "#FFFFFF"),
                    this.retrying ? "در حال تلاش مجدد..." : "تلاش مجدد",
                  ],
                ),

                h(
                  "p",
                  {
                    style: {
                      color: "#83909C",
                      fontSize: "12px",
                      lineHeight: "2",
                      margin: "22px 0 0",
                    },
                  },
                  "در صورت تداوم مشکل، لطفاً در زمان دیگری مراجعه فرمایید.",
                ),
              ],
            ),

            h(
              "footer",
              {
                style: {
                  padding: "16px 20px",
                  borderTop: `1px solid ${C.border}`,
                  background: "#FAFBFC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  color: "#8D9BA8",
                  fontSize: "11px",
                },
              },
              [icon("lock-outline", 16, "#8D9BA8"), "درگاه خدمات الکترونیکی"],
            ),
          ],
        ),
      ],
    );
  },
};

Vue.mixin({
  computed: {
    $eventBus() {
      return EventBus;
    },

    $abr() {
      const $store = this.$store;
      const $t = this.$t;
      return {
        api: {
          async fetchLookupData(lookup, cascadeValue, query, id) {
            lookup.$t = $t;
            if (!lookup.id && lookup.name) {
              lookup = $store.getters.getDefById(lookup.name);
            }

            if (lookup.clientCache?.name === "ECore.Def.DefEnums.ccWhole") {
              if (lookup.id in $store.state.lookupCache) {
                return $store.state.lookupCache[lookup.id].entries;
              } else {
                const items = await fetchLookupData(lookup);
                $store.commit("ADD_TO_LOOKUP_CACHE", {
                  lookup: lookup,
                  entries: items,
                });
                return items;
              }
            } else if (
              query ||
              query == 0 ||
              id ||
              id == 0 ||
              cascadeValue ||
              cascadeValue == 0
            ) {
              if (lookup.clientCache?.name === "ECore.Def.DefEnums.ccNone") {
                const cloneLookups = Object.assign(
                  {},
                  $store.state.lookupCache,
                );
                const otherLookups = Object.fromEntries(
                  Object.entries(cloneLookups).filter(
                    ([key]) => key !== lookup.id,
                  ),
                );

                Vue.set($store.state, "lookupCache", otherLookups);
              }

              if (
                lookup.id in $store.state.lookupCache &&
                id &&
                $store.state.lookupCache[lookup.id][+id]
              ) {
                return [$store.state.lookupCache[lookup.id][+id]];
              } else {
                // if(isNaN(id)) {
                //   console.log(this.def.name ,"55555")
                // }
                const items = await fetchLookupData(
                  lookup,
                  cascadeValue,
                  query,
                  isNaN(id) ? undefined : id,
                );
                // if (lookup.clientCache?.name !== 'ECore.Def.DefEnums.ccNone') {
                $store.commit("ADD_TO_LOOKUP_CACHE", {
                  lookup: lookup,
                  entries: items,
                });
                // }
                return items;
              }
            }
            return [];
          },
          resolveLookup(lookup, id) {
            if (!lookup.id && lookup.name) {
              lookup = $store.getters.getDefById(lookup.name);
            }

            return (
              (Array.isArray(id) &&
                id.map((id) => this.resolveLookup(lookup, id))) ||
              (id &&
                ($store.getters.resolveLookup(lookup, id) || {
                  ID: id,
                  DisplayText: id,
                }))
            );
          },
        },
      };
    },

    $formMode() {
      let p = this.$parent;
      while (p) {
        if (typeof p.submitFormRequest === "function") {
          p = p.mode.split(".").pop();
          break;
        }
        p = p.$parent;
      }
      return p || "";
      // const active = this.$store.getters.getCurrentForm;
      // return active.mode?.split(".").pop();
      // const route = this.$route;
      // return route.params && route.params.mode && route.params.mode.split(".").pop();
    },
  },
  methods: {
    $getProductInfo(kind) {
      const { state, getters } = this.$store;
      const activeTab = getters.getActiveTab;
      const { RiskCodeDefID } = this.$store.getters.getRiskModel || {};
      const benefitDefID = this.model.BenefitDefID;
      const productName =
        activeTab?.form.product?.name || this.$route.query?.ProductDefID;

      const detectLevel = (level) => {
        switch (level) {
          case "Risk":
            return state.products[productName].riskCodes.find(
              (r) => r.id === RiskCodeDefID,
            );
          case "Cover":
            return state.products[productName].riskCodes
              .find((r) => r.id === RiskCodeDefID)
              ?.benefits.find((c) => c.id === benefitDefID);
          case "Product":
            return state.products[productName];
        }
      };
      if (!productName) return {};
      if (kind) return detectLevel(kind);
      if (benefitDefID) return detectLevel("Cover");
      if (RiskCodeDefID) return detectLevel("Risk");
      return detectLevel("Product");
    },
    // this is a new function that read setting with args , didnt refactor old setting but we can use it
    $getSettingValue(level, settingSection, ParamName, valueType) {
      const productLevel = level ? level : "Product";
      const cloneProductInfo = cloneDeep(this.$getProductInfo(productLevel));
      const settingObj = !isEmpty(cloneProductInfo)
        ? cloneProductInfo.setting.sections
            .find((s) => s.name === settingSection)
            .params.find((p) => p.name === ParamName)
        : {};
      if (valueType === "Json" && !!settingObj?.value?.json) {
        return JSON.parse(settingObj.value.json);
      } else if (valueType === "Number" && !!settingObj?.value?.number) {
        return settingObj.value.number;
      }
      return settingObj;
    },

    async $checkVisibility(def) {
      if (!def?.visible) return true;
      let visible = true;
      if (this.$formMode in def.visible) {
        visible = def.visible[this.$formMode];
      } else {
        visible &= (await this.$eval(def.visible.visibleExpr)) ?? true;
      }
      return visible;
    },

    $t(key, params) {
      let t;

      const format = (str, ...args) => {
        if (args.length) {
          const type = typeof args[0];
          args =
            "string" === type || "number" === type
              ? Array.prototype.slice.call(args)
              : args[0];

          const regex = /{[^}]+}/g;
          if (regex.test(str)) {
            for (let match of str
              .match(regex)
              .filter((v, i, a) => a.indexOf(v) === i)) {
              const arg = /(?<=^{).+(?=}$)/.exec(match)[0];
              const val =
                (args && args[arg]) ||
                (key && key[arg]) ||
                this[arg] ||
                (this.model && this.model[arg]);
              if (val)
                str = str.replace(
                  new RegExp("{" + arg + "}", "gi"),
                  t(val, params),
                );
            }
          }
        }
        return str;
      };
      let found;
      const idRegex = /^[a-zA-Z0-9_\.]+$/;

      t = (key, params) =>
        format(
          typeof key == "string" &&
            key in this.$vuetify.lang.locales[this.$vuetify.lang.current]
            ? this.$vuetify.lang.t(
                key.startsWith("$vuetify.") ? key : "$vuetify." + key,
                params,
              )
            : typeof key === "string" && key.startsWith("ECore.Def.DefEnums.fm")
            ? t(key.replace(/^ECore\.Def\.DefEnums\./, "ECore.Cmn.FormMode."))
            : typeof key === "string" && !idRegex.test(key)
            ? key
            : typeof key === "string" &&
              (found = this.$store.getters.getDefById(key))
            ? t(found, params)
            : key && key.$eval && typeof key.$eval === "function"
            ? t(this.$eval(key), params)
            : key && key.label
            ? t(key.label, params)
            : key && key.resourceKey
            ? t(key.resourceKey, params)
            : key &&
              key.id &&
              key.id in this.$vuetify.lang.locales[this.$vuetify.lang.current]
            ? t(key.id, params)
            : key && key.id && !key.id.endsWith(".Label")
            ? t(key.id + ".Label", params)
            : key && key.id
            ? t(key.id, params)
            : key && key.name && key.kind && Object.keys(key).length === 2
            ? t({ id: key.name }, params)
            : key &&
              key &&
              `${key}.Label` in
                this.$vuetify.lang.locales[this.$vuetify.lang.current]
            ? t(`${key}.Label`, params)
            : key,
          params,
        );
      return t(key, params);
    },

    async $getProduct(id) {
      const store = this.$store;
      const key = id.name || id;

      if (key in store.state.products)
        return await this.$traverseData(store.state.products[key]);

      const p = await fetchDefData(id, {
        exclude: [
          ".*:TForm\\.@",
          ".*\\.CalcParams\\..*:.",
          ".*:(TCostCode|TCommCode)\\.@setting",
          ".*\\.Setting\\..*:TLabel",
          ".*:TEventHandler",
        ],
        include: [".*\\.GuaranteeTerm", ".*\\.BenefitSILimit"],
        resources: false,
        routes: false,
      });

      store.state.products[key] = this.$traverseData(p);

      return this.$traverseData(store.state.products[key]);
    },

    async $getClaim(id) {
      const store = this.$store;
      const key = id.name || id;

      if (key in store.state.claims)
        return await this.$traverseData(store.state.claims[key]);

      const p = await fetchDefData(id, {
        exclude: [".*:TForm\\.@"],
        resources: false,
        routes: false,
      });

      store.state.claims[key] = this.$traverseData(p);

      return this.$traverseData(store.state.claims[key]);
    },

    $traverseData(d) {
      const traverse = (n, f) =>
        Array.isArray(n)
          ? n.map((i) => traverse(i, f))
          : n && n.kind && f(n) && Object.keys(n).map((k) => traverse(n[k], f));

      const def = this.$store.state.root;

      const lookups = def.tiers
        .flatMap((t) => t.domains || [])
        .flatMap((t) => (t.subDomains && [t, ...t.subDomains]) || t)
        .flatMap((d) => d.lookups || []);

      const folderSubjects = def.tiers
        .flatMap((t) => t.domains || [])
        .flatMap((t) => (t.subDomains && [t, ...t.subDomains]) || t)
        .flatMap((d) => d.misc || [])
        .flatMap((m) => m.folderSubjects || []);

      const actions = def.tiers
        .flatMap((t) => t.domains || [])
        .flatMap((t) => (t.subDomains && [t, ...t.subDomains]) || t)
        .flatMap((d) => d.actions || []);

      const fns = def.tiers
        .flatMap((t) => t.domains || [])
        .flatMap((t) => (t.subDomains && [t, ...t.subDomains]) || t)
        .flatMap((d) => d.modules || [])
        .flatMap((m) => m.fns || []);

      const searchConditions =
        def.schemas
          .find((s) => s.name === "TSearchCondition")
          ?.attrs.filter((a) => a.name !== "Default")
          .map((a) => a.name.toLowerCase()) || [];

      const expandFolderSubject = (f) =>
        f.kind === "TFolderSubject" &&
        Object.assign(
          f,
          folderSubjects.find((i) => i.id === f.name),
        );

      const expandLookup = (l) =>
        l.kind === "TLookup" &&
        Object.assign(
          l,
          lookups.find((i) => i.id === l.name),
        );

      const expandActions = (a) =>
        a.kind === "TAction" &&
        Object.assign(
          a,
          actions.find((i) => i.id === a.name),
        );

      const expandValidation = (v) =>
        v.kind === "TValidation" &&
        v.preset &&
        v.preset.name &&
        Object.assign(v, {
          fn: fns.find(
            (i) =>
              i.id ===
              `ECore.Cmn.jsmValidationPreset.${v.preset.name.split(".").pop()}`,
          ),
        });

      const buildFn = (fn) => {
        try {
          fn.$call =
            (fn.script &&
              fn.script.lang &&
              fn.script.lang.name === "ECore.Def.DefEnums.slJavaScript" &&
              fn.script.script &&
              Function(fn.script.script)) ||
            (fn.script &&
              fn.script.lang &&
              fn.script.lang.name === "ECore.Def.DefEnums.slJavaScript" &&
              !fn.script.script &&
              async function (...args) {
                let module = fn.id.split(".");
                module = module.slice(0, module.length - 1).join("/");
                const m = await import("./ext/" + module);
                if (!(fn.name in m))
                  throw `Function ${fn.name} not found in module ${module}`;
                fn.$call = m[fn.name];
                return fn.$call.call(this, ...args);
              });

          return fn;
        } catch (error) {
          console.log(
            `%c something went wrong buildFn`,
            `color: #6eb5ff`,
            "==>",
            `#395 ==> Main `,
            "===>",
            fn,
            error,
          );
        }
      };

      const expandFn = (fn) => {
        try {
          return (
            fn.kind === "TFn" &&
            Object.assign(
              fn,
              fns.find((i) => i.id === fn.name),
            ) &&
            buildFn(fn)
          );
        } catch (error) {
          console.log(
            `%c something went wrong expandFn `,
            `color: #6eb5ff`,
            "==>",
            `#415 ==> Main `,
            "===>",
            fn,
            error,
          );
        }
      };

      const buildValue = (value) => {
        const { text, number, bool } = value;
        return () => text ?? bool ?? number ?? value.undefined ?? value.null;
      };

      const buildExpr = (expr) => {
        try {
          expr.$eval =
            expr.$eval ||
            (expr.value && buildValue(expr.value)) ||
            (expr.script &&
              expr.script.lang &&
              expr.script.lang.name === "ECore.Def.DefEnums.slJavaScript" &&
              expr.script.script &&
              Function(expr.script.script)) ||
            (expr.script &&
              expr.script.fn &&
              async function (...args) {
                if (!expr.script.fn.$call)
                  throw `Function ${expr.script.fn.id} can not be used in expr ${expr.id}`;
                return expr.script.fn.$call.call(this, ...args);
              });
          return expr;
        } catch (e) {
          console.log(
            `%c error in buildExpr :>>`,
            `color:rgb(233, 22, 22)`,
            "==>",
            e,
          );
          console.log("expr :>> ", expr);
        }
      };

      const buildScript = (expr) => {
        expr.$eval =
          expr.$eval ||
          (expr.script &&
            expr.lang &&
            expr.lang.name === "ECore.Def.DefEnums.slJavaScript" &&
            Function(expr.script)) ||
          (expr.fn &&
            async function (...args) {
              if (!expr.fn.$call)
                throw `Function ${expr.fn.id} can not be used in expr ${expr.id}`;
              return expr.fn.$call.call(this, ...args);
            });
        return expr;
      };

      const expandExpr = (expr) => expr.kind === "TExpr" && buildExpr(expr);

      const expandScript = (expr) =>
        expr.kind === "TScript" && buildScript(expr);

      const expandSearchProp = (p) => {
        if (p.kind === "TSearchProp" && p.conditions && p.conditions.kind) {
          const c = p.conditions;
          return Object.assign(p, {
            conditions: Object.keys(c)
              .filter((k) => searchConditions.includes(k))
              .map((k) => ({
                condition: k.toUpperCase(),
                resourceKey: `ECore.Cmn.Conditions.${k.toUpperCase()}`,
              })),
            defaultCondition:
              p.conditions.default &&
              p.conditions.default.name &&
              p.conditions.default.name.replace(/^ECore\.Def\.DefEnums\./, ""),
          });
        }
      };

      const removeLookup = (n) =>
        n.inputType && n.inputType.name === "ECore.Def.DefEnums.itText"
          ? delete n.lookup
          : n;

      const expand = (n) =>
        expandActions(n) ||
        expandFolderSubject(n) ||
        expandLookup(removeLookup(n)) ||
        expandSearchProp(n) ||
        expandValidation(n) ||
        expandFn(n) ||
        expandExpr(n) ||
        expandScript(n) ||
        n;

      traverse(d, expand);

      return d;
    },

    $lookupValue(lookupData = undefined, payload = undefined) {
      if (!lookupData) return;
      const { name } = lookupData;
      return name === "lkpDfnYesNo"
        ? typeof payload === "boolean"
          ? payload
            ? 140111
            : 140112
          : payload === 140111
        : name === "lkpDfnHasHasNot"
        ? typeof payload === "boolean"
          ? payload
            ? 140121
            : 140122
          : payload === 140121
        : name === "lkpDfnExistsNotExists"
        ? typeof payload === "boolean"
          ? payload
            ? 140131
            : 140132
          : payload === 140131
        : name === "lkpDfnActiveDeactive"
        ? typeof payload === "boolean"
          ? payload
            ? 140141
            : 140142
          : payload === 140141
        : undefined;
    },

    $processEvent(eventList, ref, args) {
      const listeners = {};
      listeners.custom = {};
      eventList.forEach((event) => {
        if (!event.clientSide) return;
        let eventPreset = event.eventPreset?.name
          .split(".")
          .pop()
          .toLowerCase();
        if (eventPreset === "custom") {
          // listeners.custom = {};
          eventPreset = event.customEventName;
          if (event.sourceFilter) {
            this.$store.dispatch("ADD_TO_EVENT_LIST", {
              target: event.sourceFilter,
              fn: async () =>
                await this.$call(
                  (!event.fn?.script?.fn &&
                    event.fn?.script?.script &&
                    event.fn) ||
                    (event.fn?.script?.fn && event.fn.script.fn),
                  args,
                ),
            });
          }
          if (event.fn) {
            if (eventPreset === "onLoad" || eventPreset === "onMounted") {
              this.$eventBus.$once(`${ref}-${eventPreset}`, async (args) => {
                await this.$call(
                  (!event.fn.script?.fn &&
                    event.fn.script?.script &&
                    event.fn) ||
                    (event.fn.script?.fn && event.fn.script.fn),
                  args,
                );
              });
            } else {
              this.$eventBus.$on(`${ref}-${eventPreset}`, async (args) => {
                await this.$call(
                  (!event.fn.script?.fn &&
                    event.fn.script?.script &&
                    event.fn) ||
                    (event.fn.script?.fn && event.fn.script.fn),
                  args,
                );
              });
            }
          }
          listeners.custom[eventPreset] = event.fn;
        } else {
          if (!Array.isArray(listeners[eventPreset]))
            listeners[eventPreset] = [];
          listeners[eventPreset].push(
            async () =>
              await this.$call(
                (!event.fn?.script?.fn &&
                  event.fn?.script?.script &&
                  event.fn) ||
                  (event.fn?.script?.fn && event.fn.script.fn),
                args,
              ),
          );
        }
      });
      return listeners;
    },

    async $target(action, model = undefined) {
      if (!action) return;
      const formId =
        action.targetForm && (action.targetForm.id ?? action.targetForm.name);

      const defaultRoute = () => {
        return {
          app: this.$store.state.app,
          name: formId,
          params: {
            formId: formId,
            mode: action.targetMode && action.targetMode.name,
            id:
              action.targetMode &&
              action.targetMode.name === "ECore.Def.DefEnums.fmCreate"
                ? "$new"
                : (model && model.ID) || "not_set",
            model: model,
            formWidth: action.targetFormWidth?.name,
          },
        };
      };
      if (action && action.targetRoute && action.targetRoute.$eval) {
        return await action.targetRoute.$eval.call({
          def: action,
          model,
          defaultRoute,
          $route: this.$route,
          ...this,
        });
      } else {
        if (!formId) return undefined;
        return defaultRoute();
      }
    },

    async $call(fn, ...args) {
      if (fn && fn.$call && typeof fn.$call === "function")
        return await fn.$call.call(this, ...args);
    },

    $bind(fn) {
      return this.$call.bind(this, fn);
    },

    $eval(expr, ...args) {
      try {
        if (expr && typeof expr.$eval === "function") {
          // console.log(this)
          return expr.$eval.call(this, ...args);
        }
      } catch (e) {
        console.log(
          `%c SOMETHING WENT WRONG IN $eval`,
          `color: #FE3D65`,
          "==>",
          `#620 ==> Main `,
          "expr",
          expr,
          "...args",
          ...args,
          "Exception:",
          e,
        );
      }
    },

    $proxy(object) {
      if (!object || object.__proxy__) return object;

      object.__proxy__ = {
        originalValues: { ...object },
        // originalValues: cloneDeep(object),
        dirty: {},
        isDirty: (prop = undefined) =>
          prop
            ? object.__proxy__.dirty[prop] ||
              (object[prop] &&
                object[prop].__proxy__ &&
                object[prop].__proxy__.isDirty())
            : Object.keys(object.__proxy__.dirty).some((k) =>
                object.__proxy__.isDirty(k),
              ),
        undo: (prop) => {
          object[prop] = object.__proxy__.originalValues[prop];
          object.__proxy__.dirty[prop] = false;
        },
      };

      object.$isDirty = object.__proxy__.isDirty;
      object.$undo = object.__proxy__.undo;
      object.$changes = object.__proxy__.changes;

      const handler = {
        // get: (target, prop) => {
        //   if(typeof prop === 'symbol' || prop.startsWith("__") || prop.startsWith("$"))
        //     return Reflect.get(target, prop)
        //   if(typeof prop !== 'symbol' && target[prop] !== null && !prop.startsWith("__") && !prop.startsWith("$") && typeof target[prop] === "object")
        //     return this.$proxy(target[prop], target, prop);
        //   return Reflect.get(target, prop)
        // },
        set: (target, prop, value, receiver) => {
          // console.log("first set trigger", target?.__proxy__?.dirty, prop, value);
          if (
            typeof prop === "symbol" ||
            prop.startsWith("__") ||
            prop.startsWith("$")
          ) {
            return Reflect.set(target, prop, value, receiver);
          }
          // if(typeof target === "object" && parentObject) {
          //   if(Array.isArray(target) && !isNaN(+prop))
          //     target.__proxy__.dirty[prop] = value !== target.__proxy__.originalValues[prop]
          //   parentObject.__proxy__.dirty[parentProp] = value !== parentObject.__proxy__.originalValues[parentProp]
          //   return Reflect.set(target, prop, value, receiver);
          // }
          target.__proxy__.dirty[prop] =
            value !== target.__proxy__.originalValues[prop];
          return Reflect.set(target, prop, value, receiver);
        },
      };
      return new Proxy(object, handler);
    },
  },
});

const buildOidcAuth = async () => {
  try {
    const instance = await fetchInstance();
    store.state.instance = instance.compId;

    const config = {
      authority: instance.authenticationAuthority,
      client_id: "abr",
      response_type: instance?.responseType,
      scope: instance?.scope,
      post_logout_redirect_uri: instance.baseUrl,

      // Store OIDC user and tokens in localStorage
      userStore: new WebStorageStateStore({
        store: window.localStorage,
      }),

      automaticSilentRenew: false,
    };

    const oidcAuth = createOidcAuth(
      "abr",
      SignInType.Window,
      instance.baseUrl,
      config,
    );

    setOidcManager(oidcAuth.mgr);

    store.commit("SET_AUTH", oidcAuth);

    Vue.prototype.$oidc = oidcAuth;

    oidcAuth.useRouter(router);


    oidcAuth.mgr.events.addAccessTokenExpiring(() => {
      console.log("Access token expiring");
    });

    oidcAuth.mgr.events.addAccessTokenExpired(() => {
      console.log("Access token expired");
    });

    oidcAuth.mgr.events.addSilentRenewError((error) => {
      console.error("Silent renew error", error);
    });

    oidcAuth.mgr.events.addUserLoaded(() => {
      console.log("OIDC user loaded");
    });

    oidcAuth.mgr.events.addUserUnloaded(() => {
      console.log("OIDC user unloaded");
    });

    oidcAuth.mgr.events.addUserSignedOut(() => {
      console.log("OIDC user signed out");
    });

    oidcAuth.mgr.events.addUserSessionChanged(() => {
      console.log("OIDC user session changed");
    });
    
     return oidcAuth;

  } catch (error) {
    console.error("Application initialization failed:", error);

    const status = error?.response?.status;

    const isServerUnavailable =
      [502, 503, 504].includes(status) ||
      (error?.isAxiosError === true && !error?.response);

    if (isServerUnavailable) {
      new Vue({
        vuetify,
        render: (h) => h(ErrorPage),
      }).$mount("#app");

      return null;
    }

    throw error;
  }
};

buildOidcAuth()
  .then(async (oidcAuth) => {
    if (!oidcAuth) return;

    const ok = await oidcAuth.startup();

    if (!ok) return;

    Vue.use(PortalVue);

    const vueApp = new Vue({
      vuetify,
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");

    vueApp.$nextTick(() => {
      vueApp.$nextTick(() => {
        if (window.applyGlobalTheme) {
          window.applyGlobalTheme(vuetify, store.state.instance || "day");
        }
      });
    });
  })
  .catch((error) => {
    console.error("Application initialization failed", error);
  });
